




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UpdateExpTableModal extends Vue {
     createnew: any;

    // Props
    @Prop({ default() { return {}; } })
    item!: any;

    // Data
    dialog = false;
    loading = false;
    form = {
        tier: this.item.tier,
        level: this.item.level,
        exp_required: this.item.exp_required,
        time_estimated_sec: this.item.time_estimated_sec
    };

    // Methods
    public async SubmitUpdate() {
        try {
            this.loading = true;
            this.item.tier = this.form.tier;
            this.item.level = this.form.level;
            this.item.exp_required = this.form.exp_required;
            this.item.time_estimated_sec = this.form.time_estimated_sec
            await this.item.patch();
            this.$emit('success');
            this.dialog = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }
}
